module.exports = __webpack_public_path__ + "img/key.89b33915.svg";